const getDefaultState = () => {
    return {
        sitAnswerCurrentStep: '1',
        diffs: [],
        addColors: {
            "light": "#E8F5E9",
            "deep": "#4CAF50",
        },
        updateColors: {
            "light": "#FFF3E0",
            "deep": "#FF9800",
        },
        deleteColors: {
            "light": "#FFEBEE",
            "deep": "#F44336",
        },
    }
}

const sitAnswer = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setSitAnswerCurrentStep(state, data) {
            state.sitAnswerCurrentStep = data
        },
        setDiffs(state, data) {
            state.diffs = data
        }
    },
}

export default sitAnswer